import {
  Companion_getInstance2xymkrjuj4ub8 as Companion_getInstance,
  Codes_CLOSED_ABNORMALLY_getInstance2rjj5xk3ewrku as Codes_CLOSED_ABNORMALLY_getInstance,
  CloseReason10cphaqpp3ct7 as CloseReason,
  Codes_NORMAL_getInstance1akc4vzdzyb59 as Codes_NORMAL_getInstance,
} from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/CloseReason.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { decodeToString1dbzcjd620q25 as decodeToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { writeFully359t6q8kam2g5 as writeFully } from '../../../../../../ktor-ktor-io/io/ktor/utils/io/core/BytePacketBuilder.mjs';
import { readText3frapgncbqrcg as readText } from '../../../../../../ktor-ktor-io/io/ktor/utils/io/Deprecation.mjs';
import { cancelConsumed2i0oizqhmljf6 as cancelConsumed } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channels.common.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableDeferred.mjs';
import { Factory_getInstance3boxsed5qz5iy as Factory_getInstance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { from3gpkuvfyl3bft as from } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketChannelsConfig.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  Text3e6ukp9joohql as Text,
  Binary3tlzyfojm51s4 as Binary,
  Close3tx65evcwi73t as Close,
} from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/Frame.web.mjs';
import { WebSocketExceptionb5mwyitzck0i as WebSocketException } from './WebSockets.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import { Key_instance2rlngjw9v1qsd as Key_instance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { send3kjrrxgwu0vpw as send } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function isReservedStatusCode($this, $receiver) {
  // Inline function 'kotlin.let' call
  var resolved = Companion_getInstance().n59($receiver);
  return resolved == null || equals(resolved, Codes_CLOSED_ABNORMALLY_getInstance());
}
var JsWebSocketSession$slambdaClass;
function JsWebSocketSession$slambda() {
  if (JsWebSocketSession$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.b60_1 = this$0;
      }
      *w1f($this$launch, $completion) {
        // Inline function 'kotlinx.coroutines.channels.consumeEach' call
        var tmp0 = this.b60_1.g60_1;
        $l$block: {
          // Inline function 'kotlinx.coroutines.channels.consume' call
          var cause = null;
          try {
            var _iterator__ex2g4s = tmp0.p1();
            while (yield* _iterator__ex2g4s.j1a($completion)) {
              var e = _iterator__ex2g4s.r1();
              switch (e.a5b_1.w1_1) {
                case 0:
                  var text = e.b5b_1;
                  this.b60_1.d60_1.send(decodeToString(text, 0, 0 + text.length | 0));
                  break;
                case 1:
                  var tmp = e.b5b_1;
                  var source = tmp instanceof Int8Array ? tmp : THROW_CCE();
                  var frameData = source.buffer.slice(source.byteOffset, source.byteOffset + source.byteLength | 0);
                  this.b60_1.d60_1.send(frameData);
                  break;
                case 2:
                  // Inline function 'io.ktor.utils.io.core.buildPacket' call

                  var builder = new (Buffer())();
                  writeFully(builder, e.b5b_1);
                  var data = builder;
                  var code = data.a4f();
                  var reason = readText(data);
                  this.b60_1.e60_1.n12(CloseReason().q59(code, reason));
                  if (isReservedStatusCode(this.b60_1, code)) {
                    this.b60_1.d60_1.close();
                  } else {
                    this.b60_1.d60_1.close(code, reason);
                  }

                  break;
                case 3:
                case 4:
                  break;
                default:
                  noWhenBranchMatchedException();
                  break;
              }
            }
            break $l$block;
          } catch ($p) {
            if ($p instanceof Error) {
              var e_0 = $p;
              cause = e_0;
              throw e_0;
            } else {
              throw $p;
            }
          }
          finally {
            cancelConsumed(tmp0, cause);
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.w1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    JsWebSocketSession$slambdaClass = $;
  }
  return JsWebSocketSession$slambdaClass;
}
function JsWebSocketSession$slambda_0(this$0) {
  var i = new (JsWebSocketSession$slambda())(this$0);
  var l = ($this$launch, $completion) => i.w1f($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var JsWebSocketSessionClass;
function JsWebSocketSession() {
  if (JsWebSocketSessionClass === VOID) {
    class $ {
      constructor(coroutineContext, websocket, channelsConfig) {
        this.c60_1 = coroutineContext;
        this.d60_1 = websocket;
        this.e60_1 = CompletableDeferred();
        this.f60_1 = from(Factory_getInstance(), channelsConfig.b5a_1);
        this.g60_1 = from(Factory_getInstance(), channelsConfig.c5a_1);
        this.h60_1 = this.f60_1;
        this.i60_1 = this.g60_1;
        this.j60_1 = this.e60_1;
        var onMessage = (e) => {
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var event = e;
          var data = event.data;
          var tmp;
          if (data instanceof ArrayBuffer) {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$2 = new Int8Array(data);
            tmp = Binary().h5e(true, tmp$ret$2);
          } else {
            if (!(data == null) ? typeof data === 'string' : false) {
              tmp = Text().r5e(data);
            } else {
              var error = IllegalStateException().o('Unknown frame type: ' + event.type);
              this.e60_1.o12(error);
              throw error;
            }
          }
          var frame = tmp;
          this.f60_1.y1a(frame);
          return Unit_instance;
        };
        var onError = (e) => {
          var cause = WebSocketException().e5w(toString(e));
          this.e60_1.o12(cause);
          this.f60_1.i1b(cause);
          this.g60_1.m1b();
          return Unit_instance;
        };
        var onClose = {_v: null};
        onClose._v = (e) => {
          var tmp = e.code;
          var tmp_0 = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
          var tmp_1 = e.reason;
          var reason = CloseReason().q59(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : THROW_CCE());
          this.e60_1.n12(reason);
          this.f60_1.y1a(Close().x5a(reason));
          this.f60_1.k1b();
          this.g60_1.m1b();
          var tmp_2;
          if (onClose._v == null) {
            throwUninitializedPropertyAccessException('onClose');
          } else {
            tmp_2 = onClose._v;
          }
          this.d60_1.removeEventListener('close', tmp_2);
          return Unit_instance;
        };
        var tmp0_safe_receiver = this.c60_1.yc(Key_instance);
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.ax((cause) => {
            $l$block: {
              // Inline function 'io.ktor.client.plugins.websocket.JsWebSocketSession.runWhenOpen' call
              if (this.d60_1.readyState === WebSocket.OPEN) {
                if (cause == null) {
                  this.d60_1.close();
                } else {
                  this.d60_1.close(Codes_NORMAL_getInstance().k59_1, 'Client failed');
                }
                break $l$block;
              }
              this.d60_1.addEventListener('open', (it) => {
                if (cause == null) {
                  this.d60_1.close();
                } else {
                  this.d60_1.close(Codes_NORMAL_getInstance().k59_1, 'Client failed');
                }
                return Unit_instance;
              });
            }
            this.d60_1.removeEventListener('message', onMessage);
            this.d60_1.removeEventListener('error', onError);
            return Unit_instance;
          });
        }
        // Inline function 'org.w3c.dom.ARRAYBUFFER' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$7 = 'arraybuffer';
        this.d60_1.binaryType = tmp$ret$7;
        this.d60_1.addEventListener('message', onMessage);
        this.d60_1.addEventListener('error', onError);
        var tmp;
        if (onClose._v == null) {
          throwUninitializedPropertyAccessException('onClose');
        } else {
          tmp = onClose._v;
        }
        this.d60_1.addEventListener('close', tmp);
        launch(this, VOID, VOID, JsWebSocketSession$slambda_0(this));
        // Inline function 'kotlin.require' call
        if (!!channelsConfig.b5a_1.i5d()) {
          var message = 'Suspendable channels are not supported in JS.';
          throw IllegalArgumentException().n2(toString(message));
        }
      }
      xv() {
        return this.c60_1;
      }
      x59() {
        return this.h60_1;
      }
      y59() {
        return this.i60_1;
      }
      t59() {
        return this.j60_1;
      }
      v59(_) {
        throw WebSocketException().e5w('Max frame size switch is not supported in Js engine.');
      }
      w59() {
        return 9223372036854775807n;
      }
      u59(negotiatedExtensions) {
        // Inline function 'kotlin.require' call
        if (!negotiatedExtensions.n1()) {
          var message = 'Extensions are not supported.';
          throw IllegalArgumentException().n2(toString(message));
        }
      }
      *i4j($completion) {
        return Unit_instance;
      }
    }
    protoOf($).z59 = send;
    initMetadataForClass($, 'JsWebSocketSession', VOID, VOID, [DefaultWebSocketSession()], [0, 1]);
    JsWebSocketSessionClass = $;
  }
  return JsWebSocketSessionClass;
}
//region block: exports
export {
  JsWebSocketSession as JsWebSocketSession2h93x4rgbt7zw,
};
//endregion

//# sourceMappingURL=JsWebSocketSession.mjs.map
